import apiFetch from '../apiFetch'

export default function () {
  return apiFetch({endPoint: `Albaran`, method: 'GET', body: null})
}
